// extracted by mini-css-extract-plugin
module.exports = {"bxTextTruncateEnd":"Grid-module--bx--text-truncate--end--3RGRz","bxTextTruncateFront":"Grid-module--bx--text-truncate--front--1muJR","column":"Grid-module--column--1wV-c"};